<script type="text/javascript" src="Scripts/bootstrap.min.js"></script>
<script type="text/javascript" src="Scripts/jquery-2.1.1.min.js"></script>

<app-global-loader></app-global-loader>

<ng-container>
    <div class="web-connection slide-top" id="on">
        <p class="msg">Connection established!</p>
    </div>
    <div class="web-connection slide-top" id="off">
        <p class="msg">No internet connection!</p>
    </div>

    <div class="scroll-to-top">
        <button *ngIf="showButton" class="go-to-top-btn" (click)="scrollToTop()">
            <i class="fas fa-arrow-up"></i>
        </button>
    </div>
</ng-container>

<router-outlet></router-outlet>
<app-one-qms-file-uploader></app-one-qms-file-uploader>